import React, { Component } from 'react';
import { Button, DropdownButton, MenuItem, FormControl, ControlLabel, FormGroup } from 'react-bootstrap';
import FaPen from "react-icons/lib/fa/pencil";
import FaTrash from "react-icons/lib/fa/trash";
import AlertConfirmation from "../confirmDelete.js";
import SwaggerAPI from "../../api/SwaggerAPI";
import { saveAs } from 'file-saver/FileSaver';

class TopMenu extends Component {
  state = {
    swagger: null,
    groupId: null
  };

  componentWillReceiveProps = ({ swagger, groupId }) => {
    this.setState({ swagger, groupId });
  }

  dateFormat = (date) => {
    let dateTransform = new Date(date).toISOString().split("T");
    dateTransform[0] = dateTransform[0].replace(/-/g, "/");
    dateTransform[1] = dateTransform[1].slice(0, 5).replace(":", "h");

    return dateTransform[0] + " (" + dateTransform[1] + ")";
  }

  deleteSwagger = () => {
    const deleteHandler = onClose => {
      SwaggerAPI.deleteSwagger(this.state.groupId, this.state.swagger.id);
      this.props.reloadSwaggers();
      onClose();
    };
    AlertConfirmation.confirmDelete(
      deleteHandler,
      `Do you want to delete the swagger ${this.state.swagger.name} ?`
    );
  }

  downloadSwagger(type, groupId, swagger) {
    let promise;
    let mediaType;
    if (type === 'json') {
      mediaType = 'text/json,charset=utf-8'
      promise = SwaggerAPI.downloadSwaggerAsJson(groupId, swagger.id)
        .then(swagger => JSON.stringify(swagger, null, 2))
    } else if (type === 'yaml') {
      mediaType = 'text/yaml,charset=utf-8'
      promise = SwaggerAPI.downloadSwaggerAsYaml(groupId, swagger.id)
    }

    promise.then(content => {
      const blob = new Blob([content], { type: mediaType });
      saveAs(blob, `${swagger.name}.${type}`);
    })
  }

  render() {
    const swaggerId = this.state.swagger ? this.state.swagger.id : null;

    return(
      <div className="top-menu black-bg">
        <Button
          className="right"
          disabled={!this.state.swagger}
          bsStyle="danger"
          onClick={this.deleteSwagger}>

          <FaTrash />
        </Button>
        <Button
          className="right"
          disabled={!this.state.swagger}
          bsStyle="primary"
          onClick={() => this.props.onEditSwagger(this.state.groupId, this.state.swagger.id)}>

          Edit <FaPen />
        </Button>
        <Button
          className="right"
          disabled={!this.state.swagger}
          onClick={() => this.props.onCompareSwagger(this.state.groupId, swaggerId)}>
          Compare
        </Button>
        <div className="button right">
          <DropdownButton disabled={!this.state.swagger} title="Download" id="download-menu">
            <MenuItem onClick={() => this.downloadSwagger('json', this.state.groupId, this.state.swagger)} eventKey="1">JSON</MenuItem>
            <MenuItem onClick={() => this.downloadSwagger('yaml', this.state.groupId, this.state.swagger)} eventKey="2">YAML</MenuItem>
          </DropdownButton>
        </div>
        <FormGroup className="version-group">
          <ControlLabel>Version: </ControlLabel>
          <FormControl
            componentClass="select"
            placeholder="select"
            className="version-selector"
            disabled={!this.state.swagger}
            onChange={this.props.onVersionChanged}>

            {this.props.versions.map(version => {
              return (<option key={version.name + version.createdAt + version.version} value={version.version}>{version.version} - {this.dateFormat(version.createdAt)}</option>)
            })}
          </FormControl>
        </FormGroup>
      </div>
    );
  }
}

export default TopMenu;



// WEBPACK FOOTER //
// ./src/components/swagger-view/TopMenu.js